export const PROMO_POPUPS_CONFIG: Record<
  PromoPopupType,
  {
    CLOSE_KEY: string
    CADENCE: number
  }
> = {
  LOGGED_OUT: {
    CLOSE_KEY: 'promo-popup-closed-logged-out',
    CADENCE: 6 * 60 * 60 * 1000,
  },
  LOGGED_IN_UNSUBSCRIBED: {
    CLOSE_KEY: 'promo-popup-closed-unsubscribed',
    CADENCE: 48 * 60 * 60 * 1000,
  },
  LOGGED_IN_TRIAL: {
    CLOSE_KEY: 'promo-popup-closed-trial',
    CADENCE: 24 * 60 * 60 * 1000,
  },
  LOGGED_IN_MONTHLY: {
    CLOSE_KEY: 'promo-popup-closed-monthly',
    CADENCE: 7 * 24 * 60 * 60 * 1000,
  },
  LOGGED_IN_YEARLY: {
    CLOSE_KEY: 'promo-popup-closed',
    CADENCE: 30 * 24 * 60 * 60 * 1000,
  },
  LOGGED_IN_CANCELLED: {
    CLOSE_KEY: 'promo-popup-closed-cancelled',
    CADENCE: 24 * 60 * 60 * 1000,
  },
}

export type PromoPopupType =
  | 'LOGGED_OUT'
  | 'LOGGED_IN_UNSUBSCRIBED'
  | 'LOGGED_IN_TRIAL'
  | 'LOGGED_IN_MONTHLY'
  | 'LOGGED_IN_YEARLY'
  | 'LOGGED_IN_CANCELLED'

export const LOGGED_IN_YEARLY_FEATURE_FLAG = 'promo-popups-subscribers-no-trial'
export const LOGGED_IN_TRIAL_FEATURE_FLAG = 'promo-popups-subscribers-trial'

export const AUTO_OPEN_DELAY = 3000
